import { h } from 'preact'
import { isParti, PageType, Parti } from '../../../domain'
import { useAppState } from '../../../../lib/redux-provider-nohooks'
import { Message } from '../../../../lib/intl/Message'
import { NavLinks } from '../../shared/NavLinks/NavLinks'
import { byOppslutning } from './parti-sort'

import s from './StorstePartier.module.css'

const NASJONALE_PARTIKATEGORIER = [1, 2]

type Props = {
  valgKey: 'ko' | 'fy'
  partier: Parti[]
  currentPage: PageType
}

export function StorstePartier(props: Props) {
  const { partier, currentPage, valgKey } = props
  const storstePartier = partier
    .filter(parti => NASJONALE_PARTIKATEGORIER.includes(parti.kategori))
    .filter(parti =>
      parti.valg.some(valg => valg.valgKey === '2019/' + valgKey && valg.antallValgdistrikter > 1)
    )
    .filter(parti => !isParti(currentPage) || parti.id !== currentPage.id)
    .sort(byOppslutning)

  return (
    <section class={s.storsteKommuner}>
      <h3>
        <Message id="nabopartier-tittel" />
      </h3>
      <NavLinks grunndata={storstePartier} sorter={false} type="parti" />
    </section>
  )
}

export function ConnectedStorstePartier() {
  const state = useAppState()

  return (
    <StorstePartier partier={state.grunndata.parti} currentPage={state.page.current} valgKey="ko" />
  )
}
